import React, { useEffect, useState } from "react";

export const PersistenceGate = ({ children }: { children: React.ReactNode }) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        // Allow all contexts to restore localStorage values before app mounts
        setTimeout(() => setReady(true), 0);
    }, []);

    if (!ready) {
        return (
            <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-background text-muted-foreground">
                <span className="brand-pill qit-loading-pill qit-loading-pill-page" aria-hidden="true" />
            </div>
        );
    }

    return <>{children}</>;
};
